(function() {
  function initJciCollectionPages(section) {
    if (!section || section.dataset.jciCollectionPagesInitialized === 'true') return;
    section.dataset.jciCollectionPagesInitialized = 'true';

  var state = {
    group: 'all',
    availableOnly: false,
    types: [],
    flags: [],
    priceMin: 0,
    priceMax: Infinity,
    sort: '',
    sortLabel: 'featured'
  };

  var items = Array.prototype.slice.call(section.querySelectorAll('[data-bombi-group]'));
  var grid = section.querySelector('[data-bombi-grid-root]');
  var originalOrder = items.slice();

  var resultCountEls = section.querySelectorAll('[data-bombi-result-count]');
  var activeCountEl = section.querySelector('[data-bombi-active-count]');
  var filterBtnLabel = section.querySelector('[data-bombi-filter-btn-label]');
  var chipRow = section.querySelector('[data-bombi-chip-row]');
  var chipList = section.querySelector('[data-bombi-chip-list]');
  var noResults = section.querySelector('[data-bombi-no-results]');
  var sidebar = section.querySelector('[data-bombi-sidebar]');
  var backdrop = section.querySelector('[data-bombi-sidebar-backdrop]');

  /* ───────────────────── Per-group filter visibility ─────────────────────
     When the active pill changes (or on first load), hide any filter
     option that has no matching products in the current group, and hide
     the entire filter <details> if every option inside is hidden. Also
     clears any selected state that just became unavailable so the visible
     grid stays consistent with the visible filters. */

  function refreshFilterAvailability() {
    var groupItems = state.group === 'all'
      ? items
      : items.filter(function(it) { return it.getAttribute('data-bombi-group') === state.group; });

    var hasInStock = false, hasSale = false, hasNew = false;

    groupItems.forEach(function(it) {
      if (it.getAttribute('data-bombi-available') === 'true') hasInStock = true;
      if (it.getAttribute('data-bombi-sale') === 'true') hasSale = true;
      if (it.getAttribute('data-bombi-new') === 'true') hasNew = true;
    });

    function hideOption(input, hide) {
      if (!input) return;
      var wrap = input.closest('.bombi-fg__opt');
      if (wrap) wrap.hidden = hide;
    }

    hideOption(section.querySelector('[data-bombi-avail]'), !hasInStock);
    if (!hasInStock) state.availableOnly = false;

    hideOption(section.querySelector('[data-bombi-flag="sale"]'), !hasSale);
    if (!hasSale) state.flags = state.flags.filter(function(f){ return f !== 'sale'; });

    hideOption(section.querySelector('[data-bombi-flag="new"]'), !hasNew);
    if (!hasNew) state.flags = state.flags.filter(function(f){ return f !== 'new'; });

    section.querySelectorAll('.bombi-fg').forEach(function(group) {
      if (group.querySelector('.bombi-price-slider')) return;
      var visibleOpt = group.querySelector('.bombi-fg__opt:not([hidden])');
      group.hidden = !visibleOpt;
    });

    syncInputs();
  }

  /* ───────────────────── Filtering + sorting ───────────────────── */

  function matches(item) {
    if (state.group !== 'all' && item.getAttribute('data-bombi-group') !== state.group) return false;

    if (state.availableOnly && item.getAttribute('data-bombi-available') !== 'true') return false;

    if (state.types.length) {
      var itype = item.getAttribute('data-bombi-type') || '';
      if (state.types.indexOf(itype) === -1) return false;
    }

    if (state.flags.indexOf('sale') !== -1 && item.getAttribute('data-bombi-sale') !== 'true') return false;
    if (state.flags.indexOf('new') !== -1 && item.getAttribute('data-bombi-new') !== 'true') return false;

    var price = (parseFloat(item.getAttribute('data-bombi-price')) || 0) / 100;
    if (price < state.priceMin || price > state.priceMax) return false;

    return true;
  }

  function activeFilterCount() {
    return (
      (state.availableOnly ? 1 : 0) +
      state.types.length +
      state.flags.length +
      (isFinite(state.priceMax) && (state.priceMin > parseFloat(section.querySelector('[data-bombi-range-min]').min) || state.priceMax < parseFloat(section.querySelector('[data-bombi-range-max]').max)) ? 1 : 0)
    );
  }

  function apply() {
    var visible = [];
    items.forEach(function(item) {
      if (matches(item)) {
        item.classList.remove('bombi-product-item--hidden');
        visible.push(item);
      } else {
        item.classList.add('bombi-product-item--hidden');
      }
    });

    if (state.sort && grid) {
      visible.sort(function(a, b) {
        switch (state.sort) {
          case 'title-ascending':  return (a.dataset.bombiTitle || '').localeCompare(b.dataset.bombiTitle || '');
          case 'title-descending': return (b.dataset.bombiTitle || '').localeCompare(a.dataset.bombiTitle || '');
          case 'price-ascending':  return (+a.dataset.bombiPrice || 0) - (+b.dataset.bombiPrice || 0);
          case 'price-descending': return (+b.dataset.bombiPrice || 0) - (+a.dataset.bombiPrice || 0);
          case 'date-ascending':   return (+a.dataset.bombiDate || 0) - (+b.dataset.bombiDate || 0);
          case 'date-descending':  return (+b.dataset.bombiDate || 0) - (+a.dataset.bombiDate || 0);
          case 'best-selling':     return 0;
        }
        return 0;
      });
      visible.forEach(function(i) { grid.appendChild(i); });
    } else if (grid) {
      originalOrder.forEach(function(i) { grid.appendChild(i); });
    }

    resultCountEls.forEach(function(el) { el.textContent = visible.length; });
    if (noResults) noResults.hidden = visible.length !== 0;

    var count = activeFilterCount();
    if (activeCountEl) {
      if (count > 0) { activeCountEl.hidden = false; activeCountEl.textContent = count; }
      else { activeCountEl.hidden = true; }
    }
    section.setAttribute('data-bombi-has-filters', count > 0 ? 'true' : 'false');

    renderChips();
  }

  /* ───────────────────── Active chips ───────────────────── */

  function chip(label, onRemove) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'bombi-chip';
    b.innerHTML = '<span>' + label + '</span><svg width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 2l6 6M8 2L2 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
    b.addEventListener('click', onRemove);
    return b;
  }

  function renderChips() {
    if (!chipList || !chipRow) return;
    chipList.innerHTML = '';
    if (state.availableOnly) chipList.appendChild(chip('in stock', function() { state.availableOnly = false; syncInputs(); apply(); }));
    state.types.forEach(function(t) { chipList.appendChild(chip(t, function() { state.types = state.types.filter(function(x){return x!==t;}); syncInputs(); apply(); })); });
    state.flags.forEach(function(f) { chipList.appendChild(chip(f === 'new' ? 'new arrivals' : 'on sale', function() { state.flags = state.flags.filter(function(x){return x!==f;}); syncInputs(); apply(); })); });

    var rMin = section.querySelector('[data-bombi-range-min]');
    var rMax = section.querySelector('[data-bombi-range-max]');
    if (rMin && rMax) {
      if (state.priceMin > parseFloat(rMin.min) || (isFinite(state.priceMax) && state.priceMax < parseFloat(rMax.max))) {
        chipList.appendChild(chip('price: ' + state.priceMin + ' – ' + (isFinite(state.priceMax) ? state.priceMax : rMax.max), function() {
          state.priceMin = parseFloat(rMin.min);
          state.priceMax = parseFloat(rMax.max);
          rMin.value = rMin.min;
          rMax.value = rMax.max;
          var pMinIn = section.querySelector('[data-bombi-price-min]');
          var pMaxIn = section.querySelector('[data-bombi-price-max]');
          if (pMinIn) pMinIn.value = rMin.min;
          if (pMaxIn) pMaxIn.value = rMax.max;
          updateSliderFill();
          apply();
        }));
      }
    }

    chipRow.hidden = chipList.children.length === 0;
  }

  function syncInputs() {
    section.querySelectorAll('[data-bombi-avail]').forEach(function(cb) { cb.checked = state.availableOnly; });
    section.querySelectorAll('[data-bombi-type]').forEach(function(cb) { cb.checked = state.types.indexOf(cb.getAttribute('data-bombi-type')) !== -1; });
    section.querySelectorAll('[data-bombi-flag]').forEach(function(cb) { cb.checked = state.flags.indexOf(cb.getAttribute('data-bombi-flag')) !== -1; });
  }

  /* ───────────────────── Pill category nav ───────────────────── */

  var headerTitleEl = section.querySelector('[data-bombi-header-title]');
  var headerCopyEl  = section.querySelector('[data-bombi-header-copy]');

  section.querySelectorAll('[data-bombi-filter]').forEach(function(pill) {
    pill.addEventListener('click', function() {
      section.querySelectorAll('[data-bombi-filter]').forEach(function(p) {
        p.classList.remove('bombi-pill--active');
        p.setAttribute('aria-selected', 'false');
      });
      pill.classList.add('bombi-pill--active');
      pill.setAttribute('aria-selected', 'true');
      state.group = pill.getAttribute('data-bombi-filter');

      var newTitle = pill.getAttribute('data-bombi-tab-title');
      var newDesc  = pill.getAttribute('data-bombi-tab-desc');
      if (headerTitleEl && newTitle) headerTitleEl.textContent = newTitle;
      if (headerCopyEl && newDesc) headerCopyEl.innerHTML = newDesc;

      refreshFilterAvailability();
      apply();
    });
  });

  /* ───────────────────── Filter inputs ───────────────────── */

  section.addEventListener('change', function(e) {
    var t = e.target;
    if (t.matches('[data-bombi-avail]')) { state.availableOnly = t.checked; apply(); return; }
    if (t.matches('[data-bombi-type]') && t.type === 'checkbox') {
      var v = t.getAttribute('data-bombi-type');
      state.types = t.checked ? state.types.concat([v]) : state.types.filter(function(x){return x!==v;});
      apply(); return;
    }
    if (t.matches('[data-bombi-flag]')) {
      var v = t.getAttribute('data-bombi-flag');
      state.flags = t.checked ? state.flags.concat([v]) : state.flags.filter(function(x){return x!==v;});
      apply(); return;
    }
  });

  /* ───────────────────── Price range ───────────────────── */

  var priceMinInput = section.querySelector('[data-bombi-price-min]');
  var priceMaxInput = section.querySelector('[data-bombi-price-max]');
  var rangeMin = section.querySelector('[data-bombi-range-min]');
  var rangeMax = section.querySelector('[data-bombi-range-max]');
  var sliderFill = section.querySelector('[data-bombi-slider-fill]');

  function updateSliderFill() {
    if (!sliderFill || !rangeMin || !rangeMax) return;
    var min = parseFloat(rangeMin.min), max = parseFloat(rangeMin.max), range = max - min;
    if (range <= 0) return;
    var l = ((parseFloat(rangeMin.value) - min) / range) * 100;
    var r = ((parseFloat(rangeMax.value) - min) / range) * 100;
    sliderFill.style.left = l + '%';
    sliderFill.style.width = (r - l) + '%';
  }

  function syncPrice() {
    state.priceMin = parseFloat(priceMinInput.value) || 0;
    state.priceMax = parseFloat(priceMaxInput.value);
    if (!isFinite(state.priceMax) || state.priceMax === 0) state.priceMax = Infinity;
    apply();
  }

  if (rangeMin && rangeMax && priceMinInput && priceMaxInput) {
    rangeMin.addEventListener('input', function() {
      if (+rangeMin.value > +rangeMax.value) rangeMin.value = rangeMax.value;
      priceMinInput.value = rangeMin.value;
      updateSliderFill();
      syncPrice();
    });
    rangeMax.addEventListener('input', function() {
      if (+rangeMax.value < +rangeMin.value) rangeMax.value = rangeMin.value;
      priceMaxInput.value = rangeMax.value;
      updateSliderFill();
      syncPrice();
    });
    priceMinInput.addEventListener('change', function() { rangeMin.value = priceMinInput.value; updateSliderFill(); syncPrice(); });
    priceMaxInput.addEventListener('change', function() { rangeMax.value = priceMaxInput.value; updateSliderFill(); syncPrice(); });
    updateSliderFill();
  }

  /* ───────────────────── Sidebar toggle ───────────────────── */

  var toggleBtn = section.querySelector('[data-bombi-sidebar-toggle]');
  var closeBtn = section.querySelector('[data-bombi-sidebar-close]');

  function setSidebar(open) {
    section.setAttribute('data-sidebar-open', open ? 'true' : 'false');
    if (sidebar) sidebar.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var filterBtnPrefix = section.querySelector('[data-bombi-filter-prefix]');
    if (filterBtnPrefix) filterBtnPrefix.textContent = open ? 'hide ' : 'show ';
    if (open && window.matchMedia('(max-width: 900px)').matches) {
      document.body.classList.add('bombi-no-scroll');
    } else {
      document.body.classList.remove('bombi-no-scroll');
    }
  }

  if (toggleBtn) toggleBtn.addEventListener('click', function() {
    setSidebar(section.getAttribute('data-sidebar-open') !== 'true');
  });
  if (closeBtn) closeBtn.addEventListener('click', function() { setSidebar(false); });
  if (backdrop) backdrop.addEventListener('click', function() { setSidebar(false); });

  var applyBtn = section.querySelector('[data-bombi-apply]');
  if (applyBtn) applyBtn.addEventListener('click', function() {
    if (window.matchMedia('(max-width: 900px)').matches) setSidebar(false);
  });

  /* ───────────────────── Clear all ───────────────────── */

  section.querySelectorAll('[data-bombi-clear-all]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      state.availableOnly = false;
      state.types = [];
      state.flags = [];
      if (rangeMin && rangeMax) {
        rangeMin.value = rangeMin.min;
        rangeMax.value = rangeMax.max;
        if (priceMinInput) priceMinInput.value = rangeMin.min;
        if (priceMaxInput) priceMaxInput.value = rangeMax.max;
        state.priceMin = parseFloat(rangeMin.min);
        state.priceMax = parseFloat(rangeMax.max);
        updateSliderFill();
      }
      syncInputs();
      apply();
    });
  });

  /* ───────────────────── Sort dropdown ───────────────────── */

  var sortRoot = section.querySelector('[data-bombi-sort-root]');
  var sortToggle = section.querySelector('[data-bombi-sort-toggle]');
  var sortLabel = section.querySelector('[data-bombi-sort-label]');
  var sortLabelWrap = section.querySelector('[data-bombi-sort-label-wrap]');
  var sortMenu = section.querySelector('.bombi-sort__menu');

  if (sortToggle && sortRoot && sortMenu) {
    sortToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = sortRoot.classList.toggle('is-open');
      sortToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    document.addEventListener('click', function(e) {
      if (!sortRoot.contains(e.target)) {
        sortRoot.classList.remove('is-open');
        sortToggle.setAttribute('aria-expanded', 'false');
      }
    });
    sortMenu.querySelectorAll('[role="option"]').forEach(function(opt) {
      opt.addEventListener('click', function() {
        // "clear sort" resets to unselected state (no sort applied, no `:` on the button)
        if (opt.hasAttribute('data-bombi-sort-clear')) {
          sortMenu.querySelectorAll('[role="option"]').forEach(function(o) { o.setAttribute('aria-selected', 'false'); });
          state.sort = '';
          state.sortLabel = '';
          if (sortLabel) sortLabel.textContent = '';
          if (sortLabelWrap) sortLabelWrap.setAttribute('data-bombi-sort-selected', 'false');
          section.setAttribute('data-bombi-sort-active', 'false');
          sortRoot.classList.remove('is-open');
          sortToggle.setAttribute('aria-expanded', 'false');
          apply();
          return;
        }
        sortMenu.querySelectorAll('[role="option"]').forEach(function(o) { o.setAttribute('aria-selected', 'false'); });
        opt.setAttribute('aria-selected', 'true');
        state.sort = opt.getAttribute('data-bombi-sort') || '';
        state.sortLabel = opt.getAttribute('data-bombi-sort-labeltext') || opt.textContent;
        if (sortLabel) sortLabel.textContent = state.sortLabel;
        if (sortLabelWrap) sortLabelWrap.setAttribute('data-bombi-sort-selected', 'true');
        section.setAttribute('data-bombi-sort-active', 'true');
        sortRoot.classList.remove('is-open');
        sortToggle.setAttribute('aria-expanded', 'false');
        apply();
      });
    });
  }

  /* ───────────────────── Grid view switchers ─────────────────────
     Two independent desktop choices:
       • wide   (filter closed) — user can pick 3 / 4 / 5
       • narrow (filter open)   — user can pick 2 / 3 / 4
     The effective column count is whichever corresponds to the
     current sidebar state, and each group's buttons only update
     its own chosen value (no `-1` offset applied on top). */

  var defaultWide = String(section.getAttribute('data-desktop-cols') || '4');
  var colsWide    = section.getAttribute('data-desktop-cols-wide')   || defaultWide;
  var colsNarrow  = section.getAttribute('data-desktop-cols-narrow') || '3';
  var mobileChosen = section.getAttribute('data-mobile-cols') || '2';

  function applyGridClasses() {
    if (!grid) return;
    var sidebarOpen = section.getAttribute('data-sidebar-open') === 'true';
    var isNarrow = window.matchMedia('(max-width: 900px)').matches;
    var effectiveDesktop = sidebarOpen && !isNarrow
      ? parseInt(colsNarrow, 10)
      : parseInt(colsWide, 10);

    [2, 3, 4, 5].forEach(function(n) { grid.classList.remove('product-list--per-row-' + n); });
    grid.classList.add('product-list--per-row-' + effectiveDesktop);
    [1, 2, 3].forEach(function(n) { grid.classList.remove('product-list--per-row-mob-' + n); });
    grid.classList.add('product-list--per-row-mob-' + mobileChosen);

    // Active pill reflects the current group's chosen value.
    section.querySelectorAll('.bombi-grid-switcher--wide [data-bombi-grid]').forEach(function(b) {
      if (b.getAttribute('data-bombi-grid') === colsWide) b.classList.add('is-active');
      else b.classList.remove('is-active');
    });
    section.querySelectorAll('.bombi-grid-switcher--narrow [data-bombi-grid]').forEach(function(b) {
      if (b.getAttribute('data-bombi-grid') === colsNarrow) b.classList.add('is-active');
      else b.classList.remove('is-active');
    });
  }

  section.querySelectorAll('.bombi-grid-switcher--wide [data-bombi-grid]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      colsWide = btn.getAttribute('data-bombi-grid');
      section.setAttribute('data-desktop-cols-wide', colsWide);
      applyGridClasses();
    });
  });
  section.querySelectorAll('.bombi-grid-switcher--narrow [data-bombi-grid]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      colsNarrow = btn.getAttribute('data-bombi-grid');
      section.setAttribute('data-desktop-cols-narrow', colsNarrow);
      applyGridClasses();
    });
  });

  section.querySelectorAll('[data-bombi-grid-mobile]').forEach(function(btn) {
    var val = btn.getAttribute('data-bombi-grid-mobile');
    if (mobileChosen === val) btn.classList.add('is-active');
    btn.addEventListener('click', function() {
      mobileChosen = val;
      section.setAttribute('data-mobile-cols', val);
      section.querySelectorAll('[data-bombi-grid-mobile]').forEach(function(b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      applyGridClasses();
    });
  });

  /* Re-apply column class whenever sidebar is toggled */
  var gridObserver = new MutationObserver(applyGridClasses);
  gridObserver.observe(section, { attributes: true, attributeFilter: ['data-sidebar-open'] });
  window.addEventListener('resize', applyGridClasses);
  applyGridClasses();

  /* ───────────────────── Init ───────────────────── */

  state.priceMin = parseFloat(rangeMin ? rangeMin.min : 0) || 0;
  state.priceMax = parseFloat(rangeMax ? rangeMax.max : Infinity) || Infinity;
  refreshFilterAvailability();
  apply();
  }

  function initAllJciCollectionPages(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('.bombi-collection-section')) initJciCollectionPages(scope);
    scope.querySelectorAll('.bombi-collection-section').forEach(initJciCollectionPages);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAllJciCollectionPages(document); });
  } else {
    initAllJciCollectionPages(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAllJciCollectionPages(event.target);
  });
})();
